import React from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SubHeader from "../SubComp/SubHeader/SubHeader";
import "./Contact.css";

const Contact = () => {
  return (
    <div className='contactPage'>
      <Header />

      <SubHeader title="Contact" text="Paintings" width="container" />

      {/* left image section  */}
      <div className="contact-container ">
        <div className="row text-white img-container">
          <div className="mb-5 col-lg-6 col-md-4 col-sm-12">
            <div className="contact-img1">
              <img
                src={require("../../Asset/contact/pattern (2).png")}
                alt="background"
              />
            </div>
            <div className="contact-img3">
              {" "}
              <img
                src={require("../../Asset/contact/Group 151.png")}
                alt="background "
              />
            </div>
            <div className="contact-img2">
              <img
                src={require("../../Asset/contact/pattern (3).png")}
                alt="background"
              />
            </div>
          </div>

          {/* Form section  */}
          <div className="col-lg-6 my-5 test">
            <h1 className="mb-3">Submit a Request</h1>
            <p>
              Please submit the form below for further assistance. Saatchi Art
              <br />
              support is available Monday-Friday.
            </p>
            <p>
              {" "}
              <b>Please choose a request type below</b>
            </p>
            <div className="me-5">
              <form>
                <div className="checkbox-container">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      value="option1"
                    />
                    <label className="form-check-label" for="inlineRadio1">
                      I am an Artist
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      value="option2"
                    />
                    <label className="form-check-label" for="inlineRadio2">
                      I am an buyer
                    </label>
                  </div>
                </div>
                <div className="row input-div">
                  <div className="my-3 col-md-6">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type here"
                    />
                  </div>
                  <div className="my-3 col-md-4">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Email
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type here"
                    />
                  </div>
                </div>
                <div className="input-div2">
                  <div className="mb-3">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Contact Reason
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Choose reason"
                    />
                  </div>
                  <div className="mb-3">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Subject
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type here"
                    />
                  </div>
                  <div className="mb-3">
                    <label
                      for="exampleFormControlTextarea1"
                      className="form-label"
                    >
                      Message
                    </label>
                    <textarea
                      className="form-control"
                      rows="5"
                      placeholder="Type here"
                    ></textarea>
                  </div>
                </div>
                <div>
                  <div className="file-input mt-3">
                    <input type="file" id="file" className="file" />
                    <label for="file">
                      <span style={{ color: "#ff7917" }}>Add file &nbsp; </span>{" "}
                      or &nbsp; Drop Files Here
                      <p className="file-name"></p>
                    </label>
                  </div>
                  <button type="button" className="contact-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
